/**
 * Tiny translation helper: one language, one file.
 */
import { typo } from '@/lib/typograf'
import strings from './ru.json'

type Strings = typeof strings

function lookup(path: string): unknown {
  return path.split('.').reduce<any>((value, key) => (value ? value[key] : undefined), strings)
}

export function t(path: string, params?: Record<string, string | number>): string {
  const value = lookup(path)
  if (typeof value !== 'string') return path

  return typo(fill(value, params))
}

/** Typograf runs after the substitution, so «{count} мест» glues to the number too. */
function fill(template: string, params?: Record<string, string | number>): string {
  if (!params) return template
  return template.replace(/\{(\w+)\}/g, (match, key) => String(params[key] ?? match))
}

/**
 * Russian plurals: the file holds three forms — 1 запрос, 2 запроса,
 * 5 запросов — and the count picks one.
 */
export function tPlural(path: string, count: number): string {
  const forms = tList(path)
  if (forms.length < 3) return forms[0] ?? path

  const mod10 = Math.abs(count) % 10
  const mod100 = Math.abs(count) % 100

  if (mod10 === 1 && mod100 !== 11) return forms[0]
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return forms[1]
  return forms[2]
}

export function tList(path: string, params?: Record<string, string | number>): string[] {
  const value = lookup(path)
  if (!Array.isArray(value)) return []
  return (value as string[]).map((item) => typo(fill(item, params)))
}

export type { Strings }
